import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class SeoService {

  constructor(
    private title: Title,
    private meta: Meta,
    @Inject(DOCUMENT) private document: any,
    @Inject(PLATFORM_ID) private platformId: string
  ) { }

  public updateTitle(title: string) {
    this.title.setTitle(title);
    this.meta.updateTag({ property: 'og:title', content: title });
  }

  public updateKeyWords(keys: string) {
    this.meta.updateTag({ name: 'keywords', content: keys });
  }

  public updateDescription(desc: string) {
    this.meta.updateTag({ name: 'description', content: desc });
    this.meta.updateTag({ property: 'og:description', content: desc });
  }

  public updateUrl(url: string) {
    this.meta.updateTag({ property: 'og:url', content: url });
  }

  public updateOpImage(url: string) {
    this.meta.updateTag({ property: 'og:image', content: url });
  }

  public updateRobotsNoIndex() {
    this.meta.updateTag({ name: 'robots', content: 'noindex' });
  }


  public createLinkForCanonicalURL(url: string) {
    if (isPlatformBrowser(this.platformId)) {
      const [links] = this.document.getElementsByTagName('link');
      links.setAttribute('href', url);
    }
  }
}
